const LateClockOutBanner = () => {
	return (
		<div className="p-8 font-bold text-center error-banner-pulse z-50 w-full">
			<p>You have been working 6 or more hours. When you clock out, you will be required to write a reason as to why.</p>
		</div>
	);
};

export default LateClockOutBanner;
